let isDesktop = false;

export const KristoffelAssortmentController = () => {
  const $beers = $('.assortment-item');

  enquire.register('(min-width:1024px)', {
    match : () => {
      isDesktop = true;
    }
  });

  enquire.register('(max-width:1023px)', {
    match : () => {
      $('.assortment-list').mCustomScrollbar({
        axis: 'x',
        mouseWheel: false,
        autoDraggerLength: false,
        scrollbarPosition: 'outside',
        documentTouchScroll: true,
        scrollButtons:{ enable: true }
      });

      isDesktop = false;
    },

    unmatch : () => {
      $('.assortment-list').mCustomScrollbar('destroy');
      isDesktop = true;
    },
  });

  $(window).on("window:resize", (e) => {
    enquire.register('(min-width:1024px)', {
      match : () => {
        isDesktop = true;
      }
    });

    enquire.register('(max-width:1023px)', {
      match : () => {
        isDesktop = false;
      },

      unmatch : () => {
        isDesktop = true;
      },
    });
  })

  // setTimeout(function() {
  //   const firstPosition = $('.assortment-list__item').first().position();
  //   positionSlider(firstPosition.left);
  // }, 2000);


  $beers.each((i, el) => {
    const $beer = $(el);
    const $parent = $beer.parent();
    const $btn = $beer.find('.circle-btn');
    const beerType = $beer.attr('data-beer-type');
    const $slide = $('.assortment-slider-slide[data-beer-type="' + beerType + '"]').parent();

    buildSliderNav($beers.not($beer), $slide);

    $btn.on('click', (e) => {
      e.preventDefault();

      let position = $parent.position();

      if(!isDesktop) {
        position = 0;
        $('body').addClass('no-scroll');
        $('body').addClass('assortment-open');
      }

      window.currentBeerClicked = $(e.currentTarget);

      if(window.circleAnimComplete) {
        if($('.assortment-slider').hasClass('show')) {
          deactivateSlider(() => {
            activateSlider($parent, $slide, position.left);
          });
        } else {
          activateSlider($parent, $slide, position.left);
        }
      }

    })
  })

  $('.close-slider, .main-nav__item').on('click', (e) => {
    deactivateSlider(()=>{});
    window.allowScroll = true;

    if(!isDesktop) {
      $('body').removeClass('no-scroll');
      $('body').removeClass('assortment-open');
    }
  });

  let resized;
  $(window).resize(function() {
      clearTimeout(resized);
      resized = setTimeout(doneResizing, 500);

  });
}


const positionSlider = (position) => {
  $('.assortment-slider').css({ 'left': position });
}

const showSlide = (slide) => {
  $('.assortment-slider__item').removeClass('show');

  setTimeout(function() {
    slide.addClass('show');
  }, 50);
}

const deactivateSlider = (callback) => {
  $('.assortment-slider__item').removeClass('show');
  $('.assortment-slider').removeClass('show');
  $('.assortment-list__item').removeClass('is-active');
  window.activeSlider = false;
  window.currentBeerClicked = null;

  setTimeout(function() {
    callback();
  }, 500);

}

const activateSlider = ($trigger, $slide, position) => {
  let pos = 0;

  if(isDesktop) {
    pos = $trigger.offset().left;
  }

  $('.assortment-list__item').not($slide).removeClass('is-active');

  setTimeout(function() {
    $trigger.addClass('is-active');
  }, 1000);

  positionSlider(position);

  $('.assortment-slider').addClass('show');
  showSlide($slide);

  if(isDesktop) {
    $('html, body').animate({
      scrollLeft: pos
    }, 800);
  }

  window.scrollPos = pos;
  window.allowScroll = false;
  window.activeSlider = true;
}


const buildSliderNav = ($otherBeers, $slide) => {
  $slide.find('.assortment-slider-slide').append('<nav class="slider-nav"></nav>');

  $otherBeers.each((i, el) => {
    const $beer = $(el);
    $slide.find('.slider-nav').append($beer.clone());
  });

  $slide.find('.slider-nav .assortment-item').on('click', (e) => {
    const beerType = $(e.currentTarget).attr('data-beer-type');
    const $slide = $('.assortment-slider-slide[data-beer-type="' + beerType + '"]').parent();

    showSlide($slide);
  })
}

const doneResizing = () => {
  // do stuff
  if(window.activeSlider) {
    positionSlider(window.currentBeerClicked.parents('.assortment-list__item').position().left);
    $('html, body').animate({
      scrollLeft: window.currentBeerClicked.parents('.assortment-list__item').offset().left
    }, 800);
  }
}



// WEBPACK FOOTER //
// ./src/js/controllers/KristoffelAssortmentController.js